import { LocaleContext, RegionContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Link from 'next/link';
import { component } from './styles.module.scss';
import getLanguage from 'Utils/getLocales/getLanguage';

const atlas = new AtlasMetadataClient();

const getLink = (locale, activeLocale, region) => {
  return locale === 'en' ? (
    <Link href='/regions/[region]' as={`/regions/${region.slug}`} key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  ) : (
    <Link href='/[locale]/regions/[region]' as={`/${locale}/regions/${region.slug}`} key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  );
};

const LocaleLinks = (props) => {
  const { locales } = props;
  const activeLocale = useContext(LocaleContext);
  const regionCode = useContext(RegionContext);
  if (!locales.includes('en')) locales.unshift('en');

  const region = atlas.getRegion(regionCode);

  const links = locales.map(locale => getLink(locale, activeLocale, region));

  return (
    <div className={`${component} font-sans`}>
      {links}
    </div>
  );
};

export default LocaleLinks;
